import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone } from 'lucide-react';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { path: '/', label: 'Home' },
    { path: '/prodotti', label: 'Prodotti' },
    { path: '/barbecue', label: 'Area Barbecue' },
    { path: '/storia', label: 'La Nostra Storia' },
    { path: '/contatti', label: 'Contatti' }
  ];

  return (
    <header 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-cream/95 backdrop-blur-sm shadow-md' : 'bg-cream'
      }`}
    >
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3 transition-opacity hover:opacity-80">
            <img 
              src="https://customer-assets.emergentagent.com/job_lombardi-salumi/artifacts/roqe4rab_LOGO-ok-2022.png" 
              alt="Salumificio Lombardi" 
              className="h-14 w-auto"
            />
            <div className="hidden md:block">
              <div className="font-serif text-burgundy text-xl font-bold leading-tight">
                Salumificio Lombardi
              </div>
              <div className="font-serif text-wood-brown text-sm">
                Dal 1957
              </div>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`font-serif text-base font-medium transition-colors duration-200 relative group ${
                  location.pathname === link.path
                    ? 'text-burgundy'
                    : 'text-wood-brown hover:text-burgundy'
                }`}
              >
                {link.label}
                <span 
                  className={`absolute bottom-0 left-0 w-0 h-0.5 bg-burgundy transition-all duration-300 group-hover:w-full ${
                    location.pathname === link.path ? 'w-full' : ''
                  }`}
                />
              </Link>
            ))}
          </nav>

          {/* Phone Number - Desktop */}
          <a 
            href="tel:0541750295"
            className="hidden lg:flex items-center space-x-2 bg-burgundy text-cream px-5 py-2.5 rounded-md font-serif font-medium transition-all duration-300 hover:bg-burgundy-dark hover:shadow-lg"
          >
            <Phone size={18} />
            <span>0541 750295</span>
          </a>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden text-burgundy p-2 hover:bg-beige rounded-md transition-colors"
            aria-label="Toggle menu"
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMobileMenuOpen && (
          <nav className="lg:hidden py-4 border-t border-beige animate-slideDown">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsMobileMenuOpen(false)}
                className={`block py-3 px-4 font-serif font-medium transition-colors rounded-md ${
                  location.pathname === link.path
                    ? 'bg-burgundy text-cream'
                    : 'text-wood-brown hover:bg-beige'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <a 
              href="tel:0541750295"
              className="flex items-center space-x-2 mt-4 mx-4 bg-burgundy text-cream px-5 py-3 rounded-md font-serif font-medium justify-center"
            >
              <Phone size={18} />
              <span>0541 750295</span>
            </a>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
